<script>
export default {
	data() {
		return { x: false }
	},
	mounted() {
		this.x = true
	},
	render(h) {
		return this.x ? this.$slots.default : null
		// return null
	},
}
</script>

